import React from 'react';
import PropTypes from 'prop-types';

import AutoSuggest from 'field/edit/resource/AutoSuggest';
import ResourceLink from 'field/edit/resource/ResourceLinkEdit';

import { getSuggestions } from 'actions/resourceActions';

// JSON contains search prop which contains dictionary for
// suggestions controller -> render search Input
const ResourceSearch = (props) => {
  const field = props.field;
  
  if (field.props.dictSearch) {
    return <AutoSuggest
      getSuggestions={query => getSuggestions(field.props.dictSearch, query)}
      onSelect={field.addResourceValue}
      disabled={field.values.length >= field.props.maxOccurs} 
      objectFormat={field.type}/>;
  }

  const advSearch = field.props.advancedSearch;
  // <field>+advancedSearch[<constraint>, <searchView>]
  if (advSearch && advSearch.length === 2) {
    const searchParameters = {
      constraint: advSearch[0],
      searchView: advSearch[1]
    };

    return <ResourceLink searchParameters={searchParameters} {...props} />;
  }
  return null;
};

ResourceSearch.propTypes = {
  field: PropTypes.object.isRequired,
};

export default ResourceSearch;